import { defineRouting } from "next-intl/routing";
import { locales, defaultLocale } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: "as-needed",
  // localeDetection: false (au lieu de true) — décision produit 2026-05-15.
  // Avant : le middleware next-intl lisait Accept-Language à chaque navigation
  // et redirigeait FR → AR automatiquement pour les visiteurs avec un navigateur
  // arabe. Résultat : un utilisateur sur sahha.ma/cardiologue voyait soudain
  // l'URL passer à /ar/cardiologue et le contenu basculer en AR sans rien
  // demander. Très désorientant ("le site est en fr et d'un coup il switch
  // en arabe").
  //
  // Sahha est FR-first par construction (langue par défaut, web maghrébin
  // francophone). On laisse les utilisateurs sur FR par défaut, et :
  //   • LocaleSuggestionBanner SUGGÈRE non-bloquante en bas de page
  //   • LocaleSwitcher dans le header permet le switch manuel
  //   • Cookie NEXT_LOCALE persiste leur choix explicite (priorité absolue)
  // Conforme à la recommandation Google :
  // https://developers.google.com/search/docs/specialty/international/managing-multi-regional-sites
  // ("don't automatically redirect users based on detected language").
  localeDetection: false,
});
